import type { CustomAgentJsonType } from '@bb/domain/dist/types/CustomAgent';
import Axios from 'axios';

const get = async (customAgentId: string) => {
  const { data } = await Axios.get<CustomAgentJsonType>(
    `/custom_agent/${customAgentId}`,
  );
  return data;
};
export default get;
